import React, { useEffect, useState } from 'react';
import UserFrom from './UsersForm';
import Select from 'react-select';
import ArtisanForm from './ArtisanForm';
import ApplicantForm from './ApplicantForm';
import CustomerForm from './CustomerForm';
import SuppliersForm from './SupplierForm';
import TrainingCenterForm from './TrainingCenterFrom';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import {
  currentUserSelector,
  userByIdSelector
} from '../../../modules/users/Selectors';
import { getUserAction } from '../../../modules/users/Actions';
// import ApplicantForm from './ApplicantForm';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import {
  AppBar,
  Button,
  ButtonBase,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Icon,
  Modal,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { FormSectionTitle, SearchableSelect } from '../../../components/form';
import { authUserProfilesSelector } from '../../../modules/auth/Selectors';
import getLangData from '../../../utils/getLangData';
// import styled from 'styled-components'

const FormEditIndex = props => {
  const { userId, getUser, currentUser, user } = props;
  // const userId = props.match.params.id
  const [page, setPage] = useState(['0']);
  const [selectedPage, setSeletectPage] = useState('');
  const [checked, setChecked] = useState('');
  const [open, setOpen] = useState(false);
  const [types, setTypes] = useState(['2', '3', '4', '5', '6', '8']);

  const [activeTab, setActiveTab] = useState(1);
  const onClickTabs = tab => {
    setActiveTab(tab);
  };

  const difference = types.filter(
    x => currentUser?.userType?.indexOf(x) === -1
  );
  console.log('first', difference);
  // setTypes(difference);

  console.log(types);
  const useStyles = makeStyles({
    active: {
      fontWeight: 'bold',
      textTransform: 'capitalize',
      borderBottom: '2px solid black'
    },
    label: {
      fontWeight: 'bold',
      textTransform: 'capitalize'
    },
    modal: {
      padding: '50px',
      // width: '60%',
      position: 'absolute',
      // height: '200px',
      width: '400px',
      // width: '200px',
      overflow: 'auto',
      top: !open ? '0%' : '50%',
      left: '50%',
      opacity: open ? '1' : '0',
      transform: 'translate(-50%, -50%)',
      // height: '100%',
      backgroundColor: 'white',
      transition: 'all .4s ease-in-out'
      // transform: 'translate(-50%, -50%)',
    },
    modalForm: {
      width: '60%',
      backgroundColor: 'white',
      overflow: 'auto',
      top: !open ? '0%' : '60%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      height: '100%',

      position: 'absolute',
      padding: '50px'
    },
    modalBtn: {
      backgroundColor: '#ecc063',
      borderRadius: '100px',
      paddingRight: '20px',
      paddingLeft: '20px',
      fontWeight: '600',
      display: 'block',
      marginLeft: 'auto',
      marginTop: '15px'
    }
  });
  const classes = useStyles();

  useEffect(() => {
    if (userId) {
      getUser(userId);
    }
    // console.log(props.match.params.id)
  }, []);

  const selectedForm = () => {
    if (selectedPage === 'artisan')
      return <ArtisanForm setPage={setPage} page={page} reload={true} />;
    else if (selectedPage === 'customer')
      return <CustomerForm setPage={setPage} page={page} reload={true} />;
    else if (selectedPage === 'supplier')
      return <SuppliersForm setPage={setPage} page={page} reload={true} />;
    else if (selectedPage === 'applicant')
      return <ApplicantForm setPage={setPage} page={page} reload={true} />;
    else if (selectedPage === 'trainingCenter')
      return <TrainingCenterForm setPage={setPage} page={page} reload={true} />;
    // return <div>applicant From</div>;
  };

  const { profiles, ...userData } = currentUser;
  const artisanData = currentUser.profiles?.artisan;
  const supplierData = currentUser.profiles?.supplier;
  const customerData = currentUser.profiles?.customer;
  const applicantData = currentUser.profiles?.applicant;
  const trainingCenterData = currentUser.profiles?.trainingCenter;
  const modalItem = () => {
    // if (difference.indexOf('3') !== -1)
    //   return <ArtisanForm setPage={setPage} page={page} />;
    // else if (difference.indexOf('4') !== -1)
    //   return <CustomerForm setPage={setPage} page={page} />;
    // else if (difference.indexOf('5') !== -1)
    //   return <SuppliersForm setPage={setPage} page={page} />;
    // else if (difference.indexOf('6') !== -1)
    //   return <ApplicantForm setPage={setPage} page={page} />;
    return (
      <>
        {difference.indexOf('3') !== -1 && (
          <ArtisanForm setPage={setTypes} page={difference} />
        )}
        {difference.indexOf('4') !== -1 && (
          <SuppliersForm setPage={setTypes} page={difference} />
        )}
        {difference.indexOf('5') !== -1 && (
          <CustomerForm setPage={setTypes} page={difference} />
        )}
        {difference.indexOf('6') !== -1 && (
          <ApplicantForm setPage={setTypes} page={difference} />
        )}
      </>
    );
  };

  console.log('userData', currentUser?.userType);
  const renderItems = () => {
    return (
      <>
        <AppBar position='static' color='default'>
          <Tabs
            indicatorColor='primary'
            variant='scrollable'
            scrollButtons='auto'
          >
            <Tab
              className={activeTab === 1 ? classes.active : classes.label}
              onClick={() => onClickTabs(1)}
              label='User Form '
            >
              User Form
            </Tab>
            {artisanData && (
              <Tab
                className={activeTab === 2 ? classes.active : classes.label}
                label={'Artisan Form'}
                onClick={() => onClickTabs(2)}
              >
                item 2
              </Tab>
            )}

            {supplierData && (
              <Tab
                className={activeTab === 3 ? classes.active : classes.label}
                label='Supplier Form '
                onClick={() => onClickTabs(3)}
              >
                item 3
              </Tab>
            )}
            {customerData && (
              <Tab
                className={activeTab === 4 ? classes.active : classes.label}
                label='Customer Form'
                onClick={() => onClickTabs(4)}
              />
            )}
            {applicantData && (
              <Tab
                className={activeTab === 5 ? classes.active : classes.label}
                label='Applicant Form'
                onClick={() => onClickTabs(5)}
              />
            )}
            {trainingCenterData && (
              <Tab
                className={activeTab === 6 ? classes.active : classes.label}
                label='Training Center Form'
                onClick={() => onClickTabs(6)}
              />
            )}
            {currentUser?.userType?.indexOf('0') === -1 &&
              currentUser?.userType?.indexOf('1') === -1 &&
              currentUser?.userType?.indexOf('7') === -1 &&
              typeof currentUser?.profiles === 'object' &&
              Object.keys(currentUser?.profiles).length < 4 && (
                <Tab
                  label='Add More'
                  onClick={() => setOpen(true)}
                  // icon={<Icon className="fas fa-plus-circle" />}
                  className={classes.label}
                >
                  <i className='fas fa-plus-circle'></i>
                </Tab>
              )}
            {/* <Tab onClick={()=> window.location.reload()} label="click me" /> */}
          </Tabs>
        </AppBar>
        {activeTab === 1 && (
          <UserFrom
            setPage={setPage}
            page={page}
            userData={userData ? userData : currentUser}
            edit={true}
          />
        )}
        {activeTab === 2 && (
          <ArtisanForm
            setPage={setPage}
            page={page}
            artisanData={artisanData}
            edit={artisanData?._id ? true : false}
          />
        )}
        {activeTab === 4 && (
          <CustomerForm
            setPage={setPage}
            page={page}
            customerData={customerData}
            edit={customerData?._id ? true : false}
          />
        )}
        {activeTab === 3 && (
          <SuppliersForm
            setPage={setPage}
            page={page}
            supplierData={supplierData}
            edit={supplierData?._id ? true : false}
          />
        )}
        {activeTab === 5 && (
          <ApplicantForm
            setPage={setPage}
            page={page}
            applicantData={applicantData}
            edit={applicantData?._id ? true : false}
          />
        )}
        {activeTab === 6 && (
          <TrainingCenterForm
            setPage={setPage}
            page={page}
            trainingCenterData={trainingCenterData}
            edit={trainingCenterData?._id ? true : false}
          />
        )}
        {
          <Modal
            open={open}
            // disableAutoFocus={true}
            disableEnforceFocus={false}
            onClose={() => {
              setOpen(false);
              setSeletectPage('');
              setChecked('');
            }}
            // children={}
          >
            {difference.length > 0 && (
              <>
                {selectedPage ? (
                  <div className={classes.modalForm}>{selectedForm()}</div>
                ) : (
                  <>
                    {' '}
                    <div className={classes.modal}>
                      <FormSectionTitle>Create profile</FormSectionTitle>
                      <RadioGroup
                        value={checked}
                        onChange={e => setChecked(e.target.value)}
                      >
                        {difference.indexOf('3') !== -1 && (
                          <FormControlLabel
                            control={
                              <Radio
                                name='checked'
                                value={'artisan'}
                                // onClick={() => setChecked('artisan')}
                              />
                            }
                            label={getLangData().profile_types.artisan}
                          />
                        )}

                        {difference.indexOf('4') !== -1 && (
                          <FormControlLabel
                            control={
                              <Radio
                                name='checked'
                                value={'customer'}
                                // onClick={() => setChecked('supplier')}
                              />
                            }
                            label={getLangData().profile_types.customer}
                          />
                        )}

                        {difference.indexOf('5') !== -1 && (
                          <FormControlLabel
                            control={
                              <Radio
                                name='checked'
                                value='supplier'
                                // onClick={() => setChecked('customer')}
                              />
                            }
                            label={getLangData().profile_types.supplier}
                          />
                        )}
                        {difference.indexOf('6') !== -1 && (
                          <FormControlLabel
                            control={
                              <Radio
                                name='checked'
                                value='applicant'
                                // onClick={() => setChecked('applicant')}
                              />
                            }
                            label={getLangData().profile_types.applicant}
                          />
                        )}
                        {difference.indexOf('8') !== -1 && (
                          <FormControlLabel
                            control={
                              <Radio
                                name='checked'
                                value='trainingCenter'
                                // onClick={() => setChecked('applicant')}
                              />
                            }
                            label={getLangData().profile_types.training_center}
                          />
                        )}
                      </RadioGroup>

                      <Button
                        onClick={() => setSeletectPage(checked)}
                        disabled={checked ? false : true}
                        // className="btn btn-primary"
                        className={classes.modalBtn}
                      >
                        Next
                      </Button>
                    </div>
                  </>
                )}
              </>
            )}
          </Modal>
        }
      </>
    );
  };
  return <>{renderItems()}</>;
};

const mapStateToProps = (state, props) => {
  const userId = props?.match?.params?.id;
  return {
    userId,
    user: userByIdSelector(state, userId),
    currentUser: currentUserSelector(state),
    currentUserProfiles: authUserProfilesSelector(state)
  };
};

const mapDispatchToProps = {
  getUser: getUserAction
};

export default connect(mapStateToProps, mapDispatchToProps)(FormEditIndex);
